export default "__VITE_ASSET__DaTTRknb__"